import * as React from "react";
import { experimentalStyled as styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FeedIcon from "@mui/icons-material/Feed";
import { Link } from "react-router-dom";
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function RegistrationForm() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Grid item xs={2} sm={4} md={4}>
          <Item >
            {" "}
            <Link to={"s1-form"} style={{ display: "flex", alignItems: "center" }}>
              <FeedIcon /> &nbsp;S1 Form
            </Link>
          </Item>
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <Item >
            {" "}
            <Link to={"s2-form"} style={{ display: "flex", alignItems: "center" }}>
              <FeedIcon /> &nbsp;S2 Form
            </Link>
          </Item>
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <Item >
            {" "}
            <Link to={"s3-form"} style={{ display: "flex", alignItems: "center" }}>
              <FeedIcon /> &nbsp;S3 Form
            </Link>
          </Item>
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <Item >
            {" "}
            <Link to={"s4-form"} style={{ display: "flex", alignItems: "center" }}>
              <FeedIcon /> &nbsp;S4 Form
            </Link>
          </Item>
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <Item >
            {" "}
            <Link to={"work-shop"} style={{ display: "flex", alignItems: "center" }}>
              <FeedIcon /> &nbsp;Workshop
            </Link>
          </Item>
        </Grid>

        <Grid item xs={2} sm={4} md={4}>
          <Item >
            {" "}
            <Link to={"training-form"} style={{ display: "flex", alignItems: "center" }}>
              <FeedIcon /> &nbsp;Training
            </Link>
          </Item>
        </Grid>

      </Grid>
    </Box>
  );
}
